import React, { useEffect, useState } from "react"
import { Link } from "react-router-dom"
import { Table } from "reactstrap"
import moment from "moment"
import { isNull } from "lodash"
import { formatNumberWithCommas } from "../../utils/utils"

// Helper function to safely parse integer values
const safeParseInt = value => {
  const parsed = parseFloat(value)
  return !isNaN(parsed) ? parsed : 0
}

const ProviderStockItemList = ({ data, searchDate, provData, visibleColumns }) => {
  const [monthCount, setMonthCount] = useState(1)

  useEffect(() => {
    let fromDate, toDate
    if (searchDate?.fromDate && searchDate?.toDate) {
      fromDate = moment(searchDate?.fromDate)
      toDate = moment(searchDate?.toDate)
    } else {
      fromDate = moment(provData?.firstDate?.date)
      toDate = moment(provData?.lastDate?.date)
    }
    setMonthCount(toDate.diff(fromDate, "months") + 1)
  }, [searchDate, provData])

  const buildInventoryRow = (item, index) => {
    const receipt = safeParseInt(item?.provider_ins_sum_first_in_qty_per_ip)
    const distribution = safeParseInt(item?.provider_outs_sum_out_quantity)
    const openingBalance = safeParseInt(item?.openingBalance)
    const totalLostQuantity = safeParseInt(item?.totalLostQuantity)
    const beforeDateDistribution = safeParseInt(item?.beforeDateDistribution)
    const otherSourceReceipt = safeParseInt(item?.other_source_receipt)
    const exchangeDistribution = safeParseInt(item?.exchange_distribution)
    const adjustmentIncrease = safeParseInt(item?.adjustment_increase)
    const adjustmentDecrease = safeParseInt(item?.adjustment_decrease)
    const adjustedOpeningBalance = openingBalance - beforeDateDistribution
    const directReceipts = Math.max(0, receipt - otherSourceReceipt)
    const amc = Math.round(distribution / monthCount)
    const balance =
      adjustedOpeningBalance +
      receipt +
      adjustmentIncrease -
      distribution -
      exchangeDistribution -
      adjustmentDecrease

    return {
      ...item,
      sn: index + 1,
      item_description: item.ip_item_description,
      opening_balance: adjustedOpeningBalance,
      lost: totalLostQuantity,
      receipts: directReceipts,
      other_source: otherSourceReceipt,
      adjustment_increase: adjustmentIncrease,
      adjustment_decrease: adjustmentDecrease,
      distribution,
      exchange: exchangeDistribution,
      amc,
      balance,
    }
  }

  if (visibleColumns?.length) {
    return (
      <div className="table-responsive">
        <Table className="table mb-0">
          <thead>
            <tr>
              {visibleColumns.map(column => (
                <th key={column.key} style={column.style}>
                  {column.label}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data?.map((item, index) => {
              const row = buildInventoryRow(item, index)
              return (
                <tr key={index}>
                  {visibleColumns.map(column => (
                    <td key={column.key} style={column.style}>
                      {column.render(row, index)}
                    </td>
                  ))}
                </tr>
              )
            })}
          </tbody>
        </Table>
        {data?.length === 0 && (
          <h5 style={{ textAlign: "center", padding: 20 }}>No Data Found</h5>
        )}
      </div>
    )
  }

  return (
    <div className="table-responsive">
      <Table className="table mb-0">
        <thead>
          <tr>
            <th>SN</th>
            {/* <th>UNFPA ITEM ID</th> */}
            <th>IP- ITEM DESCRIPTION (UNFPA ITEM ID)</th>
            {/* <th style={{ whiteSpace: "nowrap" }}>UNFPA UOM</th>
            <th style={{ whiteSpace: "nowrap" }}>IP UOM</th> */}
            <th
              style={{
                whiteSpace: "nowrap",
              }}
              className="text-info"
            >
              Opening Balance
            </th>
            <th
              style={{
                whiteSpace: "nowrap",
              }}
              className="text-info"
            >
              Lost Quantity
            </th>
            <th
              style={{
                color: "rgba(0, 170, 85)",
                whiteSpace: "nowrap",
              }}
            >
              RECEIPTS ( IN )
            </th>
            <th
              style={{
                color: "rgba(0, 170, 85)",
                whiteSpace: "nowrap",
              }}
            >
              OTHER SOURCE RECEIPTS ( IN )
            </th>
            <th
              style={{
                color: "rgba(0, 170, 85)",
                whiteSpace: "nowrap",
              }}
            >
              Adjustment Increase
            </th>
            <th style={{ color: "rgba(243, 32, 19)", whiteSpace: "nowrap" }}>
              Adjustment Decrease
            </th>

            <th style={{ color: "rgba(243, 32, 19)", whiteSpace: "nowrap" }}>
              DISTRIBUTION ( OUT )
            </th>
            <th style={{ color: "rgba(243, 32, 19)", whiteSpace: "nowrap" }}>
              EXCHANGE
            </th>
            <th
              style={{
                whiteSpace: "nowrap",
              }}
              className="text-info"
            >
              AMC
            </th>
            <th style={{ color: "rgba(0,0,255)", whiteSpace: "nowrap" }}>
              BALANCE
            </th>
          </tr>
        </thead>
        <tbody>
          {data?.length > 0 &&
            data.map((item, index) => {
              // Extract and normalize all values as integers
              const receipt = safeParseInt(
                item?.provider_ins_sum_first_in_qty_per_ip
              )
              const distribution = safeParseInt(
                item?.provider_outs_sum_out_quantity
              )
              const openingBalance = safeParseInt(item?.openingBalance)
              const totalLostQuantity = safeParseInt(item?.totalLostQuantity)
              const beforeDateDistribution = safeParseInt(
                item?.beforeDateDistribution
              )
              const otherSourceReceipt = safeParseInt(
                item?.other_source_receipt
              )
              const exchangeReceipts = safeParseInt(item?.exchange_receipts)
              const exchangeDistribution = safeParseInt(
                item?.exchange_distribution
              )
              const adjustmentIncrease = safeParseInt(item?.adjustment_increase)
              const adjustmentDecrease = safeParseInt(item?.adjustment_decrease)

              // Calculate derived values
              const adjustedOpeningBalance =
                openingBalance - beforeDateDistribution
              const directReceipts = Math.max(0, receipt - otherSourceReceipt)
              const amc = Math.round(distribution / monthCount)

              // Calculate balance with adjustments
              // Balance = Opening Balance + Receipts + Adjustments Increase - Distribution - Exchange - Adjustments Decrease
              const balance =
                adjustedOpeningBalance +
                receipt +
                adjustmentIncrease -
                distribution -
                exchangeDistribution -
                adjustmentDecrease
              return (
                <tr key={index}>
                  <td>{index + 1}</td>
                  {/* <td>{item.unfp_item_name}</td> */}
                  <td>
                    {item.ip_item_description} ({item.unfp_item_name})
                  </td>
                  <td className="text-info">
                    {formatNumberWithCommas(adjustedOpeningBalance)}
                  </td>
                  <td className="text-info">
                    {formatNumberWithCommas(totalLostQuantity)}
                  </td>

                  <td>
                    <Link
                      to={`/dashboard/provider-item-ins?itemId=${item.id}&from=${searchDate.fromDate}&to=${searchDate.toDate}`}
                      style={{ color: "rgba(0, 170, 85)" }}
                    >
                      {formatNumberWithCommas(directReceipts)}
                    </Link>
                  </td>
                  <td>
                    <Link
                      to={`/dashboard/provider-other-source-items?itemId=${item.id}&from=${searchDate.fromDate}&to=${searchDate.toDate}&type=other_source`}
                      style={{ color: "rgba(0, 170, 85)" }}
                    >
                      {formatNumberWithCommas(otherSourceReceipt)}
                    </Link>
                  </td>
                  <td>
                    <Link
                      to={`/dashboard/provider-adjustment-increase?itemId=${item.id}&from=${searchDate.fromDate}&to=${searchDate.toDate}&type=increase`}
                      style={{ color: "rgba(0, 170, 85)" }}
                    >
                      {formatNumberWithCommas(adjustmentIncrease)}
                    </Link>
                  </td>
                  <td>
                    <Link
                      to={`/dashboard/provider-adjustment-decrease?itemId=${item.id}&from=${searchDate.fromDate}&to=${searchDate.toDate}&type=decrease`}
                      style={{ color: "rgba(243, 32, 19)" }}
                    >
                      {formatNumberWithCommas(adjustmentDecrease)}
                    </Link>
                  </td>
                  <td>
                    <Link
                      to={`/dashboard/provider-item-outs?itemId=${item.id}&from=${searchDate.fromDate}&to=${searchDate.toDate}`}
                      style={{ color: "rgba(243, 32, 19)" }}
                    >
                      {formatNumberWithCommas(distribution)}
                    </Link>
                  </td>
                  <td>
                    <Link
                      to={`/dashboard/provider-exchange-items?itemId=${item.id}&from=${searchDate.fromDate}&to=${searchDate.toDate}`}
                      style={{ color: "rgba(243, 32, 19)" }}
                    >
                      {formatNumberWithCommas(exchangeDistribution)}
                    </Link>
                  </td>
                  <td className="text-info">{formatNumberWithCommas(amc)}</td>
                  <td>
                    <Link
                      to={`/dashboard/provider-item-ins?itemId=${item.id}&from=${searchDate.fromDate}&to=${searchDate.toDate}&type=balance`}
                      style={{ color: "rgba(0,0,255)" }}
                    >
                      {formatNumberWithCommas(balance)}
                    </Link>
                  </td>
                </tr>
              )
            })}
        </tbody>
      </Table>
      {data?.length === 0 && (
        <h5 style={{ textAlign: "center", padding: 20 }}>No Data Found</h5>
      )}
    </div>
  )
}

export default ProviderStockItemList
